import { ExternalLink, FileImage, ShieldCheck } from 'lucide-react';
import { mediaById, sourceById } from '../data/graph';

export function SourceList({ sourceIds, mediaIds = [], compact = false }: { sourceIds: string[]; mediaIds?: string[]; compact?: boolean }): JSX.Element {
  const sources = sourceIds.map((id) => sourceById.get(id)).filter(Boolean);
  const media = mediaIds.map((id) => mediaById.get(id)).filter(Boolean);
  return (
    <div className={`source-list ${compact ? 'is-compact' : ''}`}>
      {media.length > 0 && <div className="source-media-list">
        {media.map((asset) => asset && <div className="media-credit" key={asset.id}>
          <FileImage size={13} aria-hidden="true" />
          <span>{asset.title}</span>
          <span className="rights-badge"><ShieldCheck size={11} aria-hidden="true" />{asset.license}</span>
        </div>)}
      </div>}
      <div className="source-records">
        {sources.map((source) => source && source.url ? <a className="source-record" key={source.id} href={source.url} target="_blank" rel="noreferrer">
          <span className="source-kind">{source.kind}</span><span className="source-title">{source.title}</span>
          {!compact && <span className="source-publisher">{source.publisher}{source.author ? ` · ${source.author}` : ''}</span>}<ExternalLink size={13} aria-hidden="true" />
        </a> : source && <div className="source-record source-record-static" key={source.id}>
          <span className="source-kind">{source.kind}</span><span className="source-title">{source.title}</span>
          {!compact && <span className="source-publisher">{source.publisher}{source.author ? ` · ${source.author}` : ''}</span>}<ShieldCheck size={13} aria-hidden="true" />
        </div>)}
      </div>
    </div>
  );
}
